import styled, { css } from 'styled-components';
import { TLocalDisplayMode } from '../../../../../types/twilio';

const windowStyles = css`
  top: 30px;
  right: 30px;
  width: 270px;
  height: 205px;
  border-radius: 30px;
  z-index: 99998;
  border: 1px solid #ffffff;
  background: black;

  .participant-name {
    position: absolute;
    left: 7.86%;
    bottom: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 25px;
    z-index: 99998;
    color: #ffffff;
  }

  video {
    height: 100%;
  }

  @media only screen and (max-width: 1366px) {
    width: 240px;
    height: 180px;
    top: 20px;
    right: 20px;
    .participant-name {
      bottom: 3px;
      font-size: 14px;
      line-height: 21px;
    }
  }
`;

const windowStylesRemote = css`
  top: 30px;
  right: 30px;
  width: 205px;
  height: 270px;
  border-radius: 30px;
  z-index: 99998;
  border: 1px solid #ffffff;

  .participant-name {
    position: absolute;
    left: 7.86%;
    bottom: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 25px;
    z-index: 99998;
    color: #ffffff;
  }
  video {
    height: 100%;
  }
  @media only screen and (max-width: 1366px) {
    width: 180px;
    height: 240px;
    top: 20px;
    right: 20px;
    .participant-name {
      left: 7.86%;
      bottom: 3px;
      font-size: 14px;
      line-height: 21px;
    }
  }
`;

const windowStylesDraggable = css`
  top: 10px;
  right: 10px;
  width: 80px;
  height: 100px;
  border-radius: 15px;
  z-index: 99998;

  video {
    width: auto;
    height: 110px;
  }

  .participant-name {
    display: none;
  }
`;

const fullStylesRemote = css`
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  z-index: 99997;

  .participant-name {
    position: absolute;
    height: 40px;
    left: 3.47%;
    bottom: 25px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 40px;
    z-index: 99998;
    color: #ffffff;
  }
  video {
    width: auto;
    height: 100%;
  }

  @media only screen and (max-width: 1366px) {
    .participant-name {
      left: 3.47%;
      bottom: 10px;
      font-weight: 700;
      font-size: 15px;
      line-height: 20px;
      max-width: 150px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
      margin-bottom: 0px;
    }
  }
`;

const fullStyles = css`
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  z-index: 99997;

  .participant-name {
    position: absolute;
    height: 40px;
    left: 3.47%;
    bottom: 25px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 40px;
    z-index: 99998;
    color: #ffffff;
  }
  video {
    width: 100%;
  }

  @media only screen and (max-width: 1366px) {
    .participant-name {
      left: 3.47%;
      bottom: 10px;
      font-weight: 700;
      font-size: 15px;
      line-height: 20px;
      max-width: 150px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      align-content: center;
      margin-bottom: 0px;
    }
  }
`;

const fullStylesDraggable = css`
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  z-index: 99997;

  .participant-name {
    display: none;
  }
`;

const fullStylesRemoteDraggable = css`
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  z-index: 99997;

  .participant-name {
    display: none;
  }
`;

/**
 * https://stackoverflow.com/questions/36949747/make-video-fit-100-with-any-screen-resolution
 */
export const ParticipantSC = styled.div<{
  type: 'local' | 'remote';
  displayMode: TLocalDisplayMode;
}>`
  .video-container {
    position: absolute;
    overflow: hidden;
    ${({ displayMode, type }) => {
      return displayMode === 'full' && type === 'remote'
        ? fullStylesRemote
        : displayMode === 'full' && type === 'local'
        ? fullStyles
        : displayMode === 'window' && type === 'remote'
        ? windowStylesRemote
        : windowStyles;
    }}
  }

  &.draggable {
    .video-container {
      position: absolute;
      overflow: hidden;
      ${({ displayMode, type }) => {
        return displayMode === 'full' && type === 'remote'
          ? fullStylesRemoteDraggable
          : displayMode === 'full' && type === 'local'
          ? fullStylesDraggable
          : windowStylesDraggable;
      }}
    }

    .switch-icon {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 99999;
      cursor: pointer;
    }
  }

  video {
    min-width: auto;
    min-height: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .switch-icon {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50px;
    right: 50px;
    z-index: 99999;
    cursor: pointer;
    @media only screen and (max-width: 1366px) {
      width: 25px;
      height: 25px;
      top: 35px;
      right: 35px;
    }
  }

  .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 180px;
    z-index: 99997;
    background: linear-gradient(
      180deg,
      rgba(000, 000, 000, 0) 0%,
      rgba(000, 000, 000, 0.5) 51.04%,
      #000 100%
    );
  }
`;
